import { CompactButton } from '@/components/buttons';
import { useCurrentUser } from '@/hooks';
import { IconUser } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

export const LogoutButton = () => {
	const navigate = useNavigate();
	const { logUserOut } = useCurrentUser();
	const logout = useCallback(async () => {
		await logUserOut();
		navigate({ to: '/welcome' });
	}, [logUserOut, navigate]);
	return (
		<CompactButton leftSection={<IconUser />} onClick={logout}>
			Log Out
		</CompactButton>
	);
};
